export const environment = {
  production: true,

  firebase: {
  },

  debug: window["env.demo"]["debug"] || false,
  log: {
    auth: false,
    store: false,
  },

  smartadmin: {
    api: null,
    db: 'smartadmin-angular'
  },
  /*
    URL: "https://demoapi.ikyc.eu/api",
    BASE_URL: "https://demoapi.ikyc.eu",
    LOGINURL: "https://demoapi.ikyc.eu/token",
    
  URL: "https://demoapi.alphabank.cyprus/api",
  BASE_URL: "https://demoapi.alphabank.cyprus",
  LOGINURL: "https://demoapi.alphabank.cyprus/token",
  */
  URL: window["env.demo"]["URL"] || "Default",
  BASE_URL: window["env.demo"]["BASE_URL"] || "Default",
  LOGINURL: window["env.demo"]["LOGINURL"] || "Default",
  ContactToEmail: window["env.demo"]["ContactToEmail"] || "info@i-spiral.com",
  EmailCC: window["env.demo"]["EmailCC"] || "",
  Link: window["env.demo"]["Link"] || "",

  //CESOP API
  CESOP_URL: window["env.demo"]["CESOP_URL"],
  CESOP_BASE_URL: window["env.demo"]["CESOP_BASE_URL"],


  //BATCH SCREENING API
  BATCH_IKYC_URL: window["env.demo"]["BATCH_IKYC_URL"],
  BATCH_IKYC_BASE_URL: window["env.demo"]["BATCH_IKYC_BASE_URL"],
};
